import { apiConstants } from './apiConstants.js';
import { BenefitModel, EventModel } from './classes/index.js';

export class BenefitsService {
  constructor(httpClient, hubspotClient) {

    this.getUserBenefits = function () {
      
      const url = apiConstants.GetUserBenefits;
      

      return httpClient.get(url).then((result) => {
        let benefits = [];
        for(const benefit of result.data) {
          benefits.push(new BenefitModel(
            benefit.Id,
            benefit.IsActive,
            benefit.Featured,
            benefit.CompanyName,
            benefit.CompanyDescription,
            benefit.Title,
            benefit.Details,
            null,
            benefit.PromoCode,
            benefit.AdditionalInfoUrl,
            benefit.RedemptionLink,
            benefit.ImageLink,
            benefit.BannerImageUrl,
            benefit.FeaturedImageUrl,
            benefit.DateStart,
            benefit.DateStop,
            benefit.Terms,
            benefit.LogoUrl,
            benefit.FeaturedOrder,
            benefit.UserRating,
            benefit.ClickedMoreLikeThis,
            benefit.ClickedLessLikeThis,
            benefit.TrophyId,
            benefit.Trophy
          ))
        }
        return benefits;
      });
    };

    this.getBenefits = function () {
      
      const url = apiConstants.GetBenefits;
      
      return httpClient.get(url).then((result) => {
        let benefits = [];
        for(const benefit of result.data) {
          benefits.push(new BenefitModel(
            benefit.Id,
            benefit.IsActive,
            benefit.Featured,
            benefit.CompanyName,
            benefit.CompanyDescription,
            benefit.Title,
            benefit.Details,
            null,
            benefit.PromoCode,
            benefit.AdditionalInfoUrl,
            benefit.RedemptionLink,
            benefit.ImageLink,
            benefit.BannerImageUrl,
            benefit.FeaturedImageUrl,
            benefit.DateStart,
            benefit.DateStop,
            benefit.Terms,
            benefit.LogoUrl,
            benefit.FeaturedOrder,
            benefit.UserRating,
            benefit.ClickedMoreLikeThis,
            benefit.ClickedLessLikeThis,
            benefit.TrophyId,
            benefit.Trophy
          ))
        }
        return benefits;
      });
    };

    this.getBenefitStatistics = (from, to) => {
      const url = apiConstants.GetBenefitStatistics;

      return httpClient.post(url, { From: from, To: to }).then((result) => {
        return result.data;
      });
    }
    
    this.event = (benefitId, eventType, email, companyName, benefitName) => {
      const url = apiConstants.Event;
      const eventModel = new EventModel(benefitId, eventType);
      
      return httpClient.post(url, eventModel).then((result) => {
        this.submitToHubspot(email, this.getEventTypeName(eventType), companyName, benefitName)
        return result.data;
      });
    }

    this.getBenefitPartners = () => {
      const url = apiConstants.GetBenefitPartners;

      return httpClient.get(url).then((result) => {
        return result.data;
      });
    }

    this.saveBenefitPartner = (name, description) => {
      const url = apiConstants.SaveBenefitPartner;

      let model = {
        CompanyName: name,
        Description: description,
      };

      return httpClient.post(url, model).then((result) => {
        return result.data;
      });
    }

    this.setActiveStatus = (id, status) => {
      const url = apiConstants.SetActiveStatus;

      let model = {
        Id: id,
        IsActive: status,
      };

      return httpClient.post(url, model).then((result) => {
        return result.data;
      });
    }

    this.saveBenefit = (benefit) => {
      const url = apiConstants.SaveBenefit;

      let model = {
        PartnerId: benefit.Id,
        ImageLink: benefit.ImageLink,
        Title: benefit.Title,
        Details: benefit.Details,
        RedemptionLink: benefit.RedemptionLink,
        AdditionalInfoUrl: benefit.AdditionalInfoUrl,
        PromoCode: benefit.PromoCode,
        DateStart: benefit.DateStart,
        DateStop: benefit.DateStop,
        FeaturedImageUrl: benefit.BannerImageUrl,
        BannerImageUrl: benefit.BannerImageUrl,
      };

      return httpClient.post(url, model).then((result) => {
        return result.data;
      });
    }

    // Id is the benefit being edited, PartnerId the company it belongs to. Sending only
    // PartnerId made the API bind an Id of 0 and insert a duplicate instead of updating.
    this.updateBenefit = (benefit) => {
      const url = apiConstants.UpdateBenefit;

      let model = {
        Id: benefit.Id,
        PartnerId: benefit.PartnerId,
        ImageLink: benefit.ImageLink,
        Title: benefit.Title,
        Details: benefit.Details,
        RedemptionLink: benefit.RedemptionLink,
        AdditionalInfoUrl: benefit.AdditionalInfoUrl,
        PromoCode: benefit.PromoCode,
        DateStart: benefit.DateStart,
        DateStop: benefit.DateStop,
        FeaturedImageUrl: benefit.BannerImageUrl,
        BannerImageUrl: benefit.BannerImageUrl,
      };

      return httpClient.post(url, model).then((result) => {
        return result.data;
      });
    }

    this.updateFeatured = (ids) => {
      const url = apiConstants.UpdateFeatured;

      return httpClient.post(url, ids).then((result) => {
        return result.data;
      });
    }

    this.submitToHubspot = (email, eventType, companyName, benefitName) => {
      const url = apiConstants.EventForm;

      let entry;
      if(companyName !== null && benefitName !== null){
        entry = [
          { name: 'email', value: email },
          { name: 'event_type', value: this.getEventTypeName(eventType) },
          { name: 'benefit_company_name', value: companyName },
          { name: 'benefit_name', value: benefitName },
        ];
      } else {
        entry = [
          { name: 'email', value: email },
          { name: 'event_type', value: this.getEventTypeName(eventType) },
        ]
      }
    
      const communication = [{ value: true, subscriptionTypeId: 999, text: 'I agree to receive marketing communications from PlayMoreGolf Company.' }];
      const consent = { consent: { consentToProcess: true, text: 'I agree to allow PlayMoreGolf Company to store and process my personal data.', communications: communication } };
    
      const body = { fields: entry, legalConsentOptions: consent };
    
      return hubspotClient.post(url, body).then(result => result);
    }

    this.getEventTypeName = (type) => {
      switch(type) {
        case 0: return 'Clicked to see more';
        case 1: return 'Clicked claim info';
        case 2: return 'Clicked external info link';
        case 3: return 'Clicked redeem link';
        case 4: return 'Redeemed';
        case 5: return 'Clicked to see more like this';
        case 6: return 'Clicked to see less like this';
        case 7: return 'Visited more benefits';
        default: return type;
      }
    }
  }
}